<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import { format } from 'date-fns'
	import { styles } from '../library/scripts/styles'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import { new_content, get_file_size, create_navigation, sort_blocks } from '../library/scripts/utils.js'
	import { getCookie } from '../library/scripts/cookie'
	import {
		storeActiveBlock,
		storeShowFinishedBlocks,
		storeRemainingStorage,
		storeFinishedContent,
		storeUpdate,
		storeUpdateContact,
		storeUpdateSingle,
		storeShowMail,
	} from '../library/scripts/Store.svelte'

	import CreateButtons from '../components/CreateBlockButtons.svelte'
	import FinishedContent from '../components/FinishedContent.svelte'
	import UpdateBlock from '../components/UpdateBlock.svelte'
	import UpdateContact from '../components/UpdateContact.svelte'
	import UpdateMenu from '../components/UpdateMenu.svelte'
	import UpdateBooking from '../components/UpdateBooking.svelte'
	import UpdateMail from '../components/UpdateMail.svelte'
	import Logo from '../components/UpdateLogo.svelte'
	import Social from '../components/UpdateSocial.svelte'

	const globals = getContext('globals')
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsXS = globals.fsXS
	const adminColorMain = globals.adminColorMain
	const colorError = globals.colorError
	const adminBgDark = globals.adminBgDark
	let selectedBlock = null
	let userName = null

	const userID = getCookie('id')
	if (!userID) document.location = '/#/'

	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	const get_user = async (userID) => {
		let finishedBlocks = []
		let linkedSites = []
		const userData = await admin({ cmd: 'get_user' })
		isAdmin = userData ? true : false

		//get the finished blocks from config file
		const configFile = await admin({
			cmd: 'get_config_file',
		})

		userName = configFile.username
		//add the navigation
		create_navigation('add')

		if (!updateSingle) {
			configFile.blocks.forEach((file) => {
				if (file.blockName !== 'navbar') {
					if (!file.isLinked) finishedBlocks.push(file.blockName)
					if (file.isLinked) linkedSites.push(file.blockName)
				}
			})
		} else {
			finishedBlocks.push(updateSingle)
		}

		finishedBlocks.sort()
		finishedBlocks = sort_blocks(finishedBlocks)
		storeFinishedContent.set({ finishedBlocks: finishedBlocks, linkedSites: linkedSites })
		return userData
	}

	let isAdmin = false

	const oldStorage = get_file_size()
	oldStorage.then((value) => {
		storeRemainingStorage.set(value)
	})

	let storage = null
	const getStorage = storeRemainingStorage.subscribe((value) => {
		storage = value
	})

	const userData = get_user(userID)

	//selected block
	const select_block = (e) => {
		selectedBlock = e.detail.block
		storeShowFinishedBlocks.set(false)
		storeActiveBlock.set(selectedBlock)
		new_content(selectedBlock)
	}

	//update or create contact details
	let updateContact
	const stoUpdtContact = storeUpdateContact.subscribe((value) => {
		updateContact = value
		if (updateContact) storeShowFinishedBlocks.set(false)
	})

	//update block
	let updateBlock
	const stoUpdt = storeUpdate.subscribe((value) => {
		updateBlock = value
	})

	const update_block = (e) => {
		if (e.detail.blockName === 'contact') {
			storeUpdateContact.set(true)
			storeActiveBlock.set(e.detail.blockName)
			selectedBlock = e.detail.blockName
			return
		}

		if (e.detail.blockName === 'mail') {
			storeShowFinishedBlocks.set(false)
			storeShowMail.set(true)
			storeActiveBlock.set(e.detail.blockName)
			selectedBlock = e.detail.blockName
			return
		}

		updateBlock = true
		storeUpdate.set(true)
		storeActiveBlock.set(e.detail.blockName)
		selectedBlock = e.detail.blockName
	}

	onMount(() => {
		document.querySelector('body').style.backgroundColor = adminBgDark
	})

	onDestroy(() => {
		getStorage
		stoUpdt
		stoUpdtContact
		stoUpdateSingle
	})
</script>

<body use:styles={{ adminBgDark }}>
	<main use:styles={{ fsN, adminColorMain }}>
		{#await userData then data}
			{#if !isAdmin}
				<div class="error" use:styles={{ fsL, colorError }}>! NO ACCESS !</div>
			{:else}
				<div class="title" use:styles={{ fsN, adminColorMain }}>
					{#if !updateSingle}
						<span class="text" use:styles={{ fsN, adminColorMain }}>Welcome to your upload-page</span>
						<span data-small use:styles={{ fsXS, colorError }}>remaining storage: {storage} MB</span>
					{:else}
						<span class="text" use:styles={{ fsN, adminColorMain }}>UPDATE BLOCK</span>
						<span data-small use:styles={{ fsXS, colorError }}>remaining storage: {storage} MB</span>
					{/if}
				</div>

				<CreateButtons on:selectblock={select_block} />

				{#if selectedBlock === 'cover-slider'}
					<UpdateBlock blockName={'cover-slider'} maxContent="5" />
				{:else if selectedBlock === 'gallery'}
					<UpdateBlock blockName="gallery" maxContent="23" />
				{:else if selectedBlock && (selectedBlock.indexOf('block') > -1 || selectedBlock.indexOf('Block') > -1)}
					<UpdateBlock blockName={selectedBlock} />
				{:else if selectedBlock === 'logo'}
					<Logo maxContent="1" />
				{:else if updateContact}
					<UpdateContact />
				{:else if selectedBlock === 'foods'}
					<UpdateMenu blockName={selectedBlock} />
				{:else if selectedBlock === 'drinks'}
					<UpdateMenu blockName={selectedBlock} />
				{:else if selectedBlock === 'booking'}
					<UpdateBooking blockName={selectedBlock} />
				{:else if selectedBlock === 'rooms'}
					<UpdateMenu blockName={selectedBlock} />
				{:else if selectedBlock === 'mail'}
					<UpdateMail blockName={selectedBlock} />
				{:else if selectedBlock === 'shop'}
					<UpdateMenu blockName={selectedBlock} />
				{:else if selectedBlock === 'social'}
					<Social blockName={selectedBlock} />
				{/if}
			{/if}
			{#if !updateBlock}
				<FinishedContent on:onupdate={update_block} />
			{/if}
		{/await}
	</main>
</body>

<style>
	body {
		background-color: var(--adminBgDark);
	}
	main {
		width: 100vw;
		display: flex;
		flex-direction: column;
		font-size: var(--fsN);
		color: var(--adminColorMain);
	}

	.title {
		width: 100%;
		display: flex;
		padding-top: 1%;
		flex-direction: column;
		align-items: center;
		color: var(--adminColorMain);
		font-size: var(--fsN);
	}
	.error {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 90vh;
		color: var(--colorError);
		font-size: var(--fsL);
	}

	[data-small] {
		color: var(--colorError);
		font-size: var(--fsXS);
	}
</style>
